import './bootstrap';
import  './init';
import  './import/cookies';
import  'fslightbox';

import LazyLoad from "vanilla-lazyload";
window.lazyLoadInstance = new LazyLoad();

window.addEventListener('resize', function(event) {
    window.lazyLoadInstance.update();
}, true);
window.addEventListener('DOMContentLoaded', function(event) {
    window.lazyLoadInstance.update();
}, true);

document.addEventListener('touchstart', function () {
    window.Cookies.set('touched', true, 0.008);
});
